/** Role of the local participant in a meeting (not an ARIA role). */
export type MeetingRoomRole = 'student' | 'lecturer';

/** Device and mute choices from the pre-join lobby. */
export type MeetingJoinSettings = {
  audioDeviceId?: string;
  videoDeviceId?: string;
  microphoneEnabled: boolean;
  cameraEnabled: boolean;
};

export const defaultMeetingJoinSettings: MeetingJoinSettings = {
  microphoneEnabled: true,
  cameraEnabled: true,
};
